var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4165 1.66669H7.58318C7.01651 1.66669 6.2165 2.00002 5.8165 2.40002L2.39984 5.8167C1.99984 6.2167 1.6665 7.01669 1.6665 7.58336V12.4167C1.6665 12.9833 1.99984 13.7833 2.39984 14.1833L5.8165 17.6C6.2165 18 7.01651 18.3334 7.58318 18.3334H12.4165C12.9832 18.3334 13.7832 18 14.1832 17.6L17.5998 14.1833C17.9998 13.7833 18.3332 12.9833 18.3332 12.4167V7.58336C18.3332 7.01669 17.9998 6.2167 17.5998 5.8167L14.1832 2.40002C13.7832 2.00002 12.9832 1.66669 12.4165 1.66669Z",
    stroke: "#F75555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 12.9166L12.9168 7.08331",
    stroke: "#F75555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9168 12.9166L7.0835 7.08331",
    stroke: "#F75555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.40897fc39b48c8275c3dcc61b6305dd2.svg";
export { ForwardRef as ReactComponent };